import { Component, effect, inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe, DatePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { AvatarComponent, UnavailableComponent, ValueNameComponent } from '@shared/components';
import { CountryNamePipe, InitialsPipe, MediaSrcPipe, RoleSeverityPipe } from '@shared/pipes';
import { UserFacade } from '@app/store/user';
import { DeleteButtonComponent } from './delete-button/delete-button.component';

@Component({
    selector: 'app-user-view-modal',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.css'],
    imports: [
        TranslateModule,
        AsyncPipe,
        DatePipe,
        ButtonModule,
        TagModule,
        AvatarComponent,
        InitialsPipe,
        MediaSrcPipe,
        RoleSeverityPipe,
        CountryNamePipe,
        DeleteButtonComponent,
        UnavailableComponent,
        ValueNameComponent,
    ],
})
export class ViewComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly userFacade = inject(UserFacade);

    readonly user = this.userFacade.user;
    readonly loading = this.userFacade.loading;
    readonly error = this.userFacade.error;
    readonly saving = this.userFacade.saving;

    constructor() {
        const id = this.route.parent?.snapshot.params['id'];
        if (id) {
            this.userFacade.getUser(id);
        }

        effect(() => {
            if (this.userFacade.saved()) {
                this.close({ replaceUrl: !this.userFacade.user() });
            }
        });
    }

    ngOnDestroy(): void {
        this.userFacade.clear();
    }

    onEdit(): void {
        const user = this.user();
        if (user) {
            this.router.navigate([{ outlets: { modal: ['users', 'edit', user.id] } }]);
        }
    }

    close({ replaceUrl } = { replaceUrl: false }): void {
        this.router.navigate([{ outlets: { modal: null } }], { replaceUrl });
    }
}
